import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
// import { searchStudents } from "../components/searchStudent/constants";
import { useWizard } from "../../../components/wizard/WizardContext";
import {
  validateTransferStudent,
  fetchStudentSummary,
  fetchAdjustmentSummaryApi,
} from "../apis";
import { useEffect, useState } from "react";

export const useSearchStudentsHandler = () => {
  const { setSearchWizard, dropdowns, updateValues } = useWizard();

  const searchHandler = async (
    filters,
    offset = 0,
    shouldShowWizard = null,
    limit = 50,
    searchStudents = () => {},
    successCb = () => {}
  ) => {
    try {
      updateValues("searchStudentsLoading", true);
      const response = await searchStudents(
        filters,
        offset,
        dropdowns?.data,
        limit
      );

      if (response?.code === 200) {
        // set filter  to context
        updateValues("searchStudentsFilters", filters);
        const list =
          response?.data?.studentApplicationDetailsSearchResponseDTOList;
        if (!list?.length) {
          failureToast("No matching result found!");
          updateValues("searchStudentsListing", {
            list: [],
            currentPage: 0,
            totalPage: 0,
            totalRecords: 0,
          });
          return;
        }

        if (shouldShowWizard) {
          setSearchWizard((prev) => ({ ...prev, isShow: false }));
        }

        const { currentPage, totalPage, totalRecords } = response?.data;
        const searchResult = { list, currentPage, totalRecords, totalPage };
        updateValues("searchStudentsListing", searchResult);

        successCb(searchResult);
      }
    } catch (err) {
      console.error("Search failed due to ", err);
      failureToast("Search failed. Please try again.");
    } finally {
      updateValues("searchStudentsLoading", false);
    }
  };

  return { searchHandler };
};

const transformToTransferPayload = (student) => {
  return {
    psid: student.psid,
    programAction: student.programAction,
    outApplicationId: student.applicationId,
    courseId: student.courseId,
    businessAreaId: student.businessArea,
    businessAreaValue: student.businessAreaDispVal,
    academicCareerValue: student.academicCareerValue,
    termId: student.term || null,
    termValue: student.termDispVal || null,

  };
};

const formatSRequestForAdjustment = (
  transferIn,
  transferOut,
  inApplicationId
) => {
  return {
    psId: transferOut?.psid,
    outApplicationId: transferOut?.applicationId ?? transferOut?.transferOutAppId,
    outCourseId: transferOut?.courseId ?? transferOut?.outCourseId?.[0],
    outBusinessId: transferOut?.businessArea ?? transferOut?.outBusinessUnitId,
    outBusinessAreaValue: transferOut?.businessAreaDispVal ?? transferOut?.outBusinessArea,
    outStreamId: transferOut?.academicGroup ?? transferOut?.outAcademicGroupId,
    outTermId: transferOut.term?.id ?? transferOut?.outTermId,
    outTermValue: transferOut?.term?.dispValue ?? transferOut?.outTerm?.[0],
    inApplicationId: inApplicationId, // new application ID after transfer
    inCourseId: parseInt(transferIn?.courseId?.value??transferIn?.inCourseId),
    inBusinessId: transferIn?.businessArea?.value ?? transferIn?.inBusinessUnitId,
    inBusinessAreaValue: transferIn?.businessArea?.label ?? transferIn?.businessArea,
    inStreamId: transferIn?.academicGroup?.value ?? transferIn?.inAcademicGroupId,
    inTermId: transferIn?.term?.value ?? transferIn?.inTermId,
    inTermValue: transferIn?.term?.label ?? transferIn?.inTerm?.[0],
  };
};

export const useValidateTransferDetails = () => {
  const { next, updateValues } = useWizard();

  const validate = async (selectedStudent) => {
    try {
      updateValues("searchStudentsLoading", true);
      const response = await validateTransferStudent(
        transformToTransferPayload(selectedStudent)
      );
      if (response?.code === 200 && response?.data?.isTransferValid) {
        next();
      }
    } catch (err) {
      console.error(err);
      failureToast("validation failed. Please try again.");
    } finally {
      updateValues("searchStudentsLoading", false);
    }
  };

  return { validate };
};

export const useFetchTransferInSummary = (applicationId, businessArea) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tInBalanceAmount, setTinBalanceAmount] = useState(0);

  useEffect(() => {
    if (!applicationId || !businessArea) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetchStudentSummary(applicationId, businessArea);
        const feeSummaryList = response?.data?.feeSummaryDTOList || [];
        const transformedRows = feeSummaryList.reduce(
          (acc, item) => acc.concat(item.feeBreakupDTOList || []),
          []
        );
        setTinBalanceAmount(
          transformedRows.reduce((acc, item) => acc + item?.balanceAmount, 0)
        );
        setRows(transformedRows);
      } catch (error) {
        console.error("Error fetching fee breakup:", error);
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [applicationId, businessArea]);

  return { rows, loading, tInBalanceAmount };
};

export const useFetchAdjustmentInSummary = (transferIn, transferOut) => {
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!(transferOut?.applicationId || transferOut?.transferOutAppId) || !(transferOut?.businessArea|| transferOut?.outBusinessUnitId )) return;

    const fetchData = async () => {
      setLoading(true);
      setSummary([]);
      try {
        const response = await fetchAdjustmentSummaryApi(
          formatSRequestForAdjustment(transferIn, transferOut)
        );
        const feeSummaryList = response?.data || [];
        setSummary(feeSummaryList);
      } catch (error) {
        console.error("Error fetching adjustment summary:", error);
        setSummary([]);
      } finally {
        setLoading(false);
      }
    };

  transferOut && transferIn && fetchData();
  }, [transferOut, transferIn]);

  return { summary, loading };
};
